import { render, staticRenderFns } from "./ActorEditMultimedia.vue?vue&type=template&id=d9b6f248&scoped=true&"
import script from "./ActorEditMultimedia.vue?vue&type=script&lang=js&"
export * from "./ActorEditMultimedia.vue?vue&type=script&lang=js&"
import style0 from "./ActorEditMultimedia.vue?vue&type=style&index=0&id=d9b6f248&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b6f248",
  null
  
)

export default component.exports